<template>
    <v-card>
        <v-card-title class="grey lighten-4 p-2">
            <h4 class="m-0">Contact information</h4><h5 class="mb-0 ml-3 text-danger">(Billing Address)</h5>
        </v-card-title>

        <v-row class="m-2">
            <v-col cols="12">
                <h5>
                    <v-icon>mdi-account</v-icon>
                    Basic info
                </h5>
                <v-row>
                    <v-col cols="12" md="4" sm="6">
                        <with-validation v-slot="{bind,on}" field="first_name">
                            <v-text-field v-bind="bind"
                                          :autocomplete="autofillStatus?'kiosk_first_name':'off'"
                                          v-on="on">
                            </v-text-field>
                        </with-validation>
                    </v-col>
                    <v-col cols="12" md="4" sm="6">
                        <with-validation v-slot="{bind,on}" field="last_name">
                            <v-text-field v-bind="bind"
                                          :autocomplete="autofillStatus?'kiosk_last_name':'off'"
                                          v-on:keydown.enter.tab="processTags($event)"
                                          v-on="on">
                            </v-text-field>
                        </with-validation>
                    </v-col>
                    <v-col cols="12" md="4" sm="6" v-if="!is_international_canadian || (is_international_canadian && enable_international_customer)">
                        <with-validation :context='self()' v-slot="{bind,on}" field="is_international_customer">
                            <v-checkbox
                                v-bind="bind"
                                v-on="on"
                                :true-value="true"
                                :false-value="false"
                                class="d-inline-flex"
                            ></v-checkbox>
                        </with-validation>
                    </v-col>
                    <v-col cols="12" md="4" sm="6">
                        <v-slide-x-transition>
                            <with-validation :context='self()' v-slot="{bind,on}" field="country">
                                <v-autocomplete
                                    v-bind="bind"
                                    v-on="on"
                                    ref="country_select"
                                    :autocomplete="autofillStatus?'kiosk_country':'off'"
                                    v-if="reservation.is_international_customer"
                                    :items="countries"
                                    item-text="name"
                                    item-value="code"
                                >
                                </v-autocomplete>
                            </with-validation>
                        </v-slide-x-transition>
                    </v-col>
                </v-row>


            </v-col>

            <v-col
                cols="12"
            >
                <h5>
                    <v-icon>mdi-map-marker</v-icon>
                    Address info
                </h5>

                <v-row>
                    <v-col cols="12" md="6">
                        <with-validation :context='self()' v-slot="{bind,on}" field="address_primary">
                            <v-text-field
                                v-bind="bind"
                                :autocomplete="autofillStatus?'kiosk_address_primary':'off'"
                                ref="address_primary_ref"
                                v-on="on"
                            ></v-text-field>
                        </with-validation>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <with-validation :context='self()' v-slot="{bind,on}" field="city">
                            <v-text-field
                                v-bind="bind"
                                :autocomplete="autofillStatus?'kiosk_city':'off'"
                                v-on="on"
                            ></v-text-field>
                        </with-validation>
                    </v-col>
                    <template v-if="!reservation.is_international_customer && !is_international_canadian">
                        <v-col cols="12" md="4">
                            <div class="v-select__slot cus-mt-5 cus-animation" v-on:click="$event.stopPropagation()">
                                <label for="state" id="stateLabel" class="cus-select-label v-label v-label--active theme--light">State</label>
                                <with-validation :context='self()' v-slot="{bind,on}" field="state">
                                    <!--                <v-autocomplete-->
                                    <!--                    v-bind="bind"-->
                                    <!--                    v-on="on"-->
                                    <!--                    ref="state_select"-->
                                    <!--                    menu-props="auto"-->
                                    <!--                    class="smaller-list"-->
                                    <!--                    @update:search-input="testStateInput"-->
                                    <!--                    :items="states"-->
                                    <!--                    item-text="name"-->
                                    <!--                    item-value="abbreviation">-->

                                    <!--                </v-autocomplete>-->

                                    <select name="state" id="state" v-on:click="addAnimation('stateLabel')" class="cus-select form-control smaller-list v-text-field v-select__selection--comma v-select" v-model="reservation.state">
                                        <option v-for="(item, key) in states" :value="item.abbreviation" :key="key">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </with-validation>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <with-validation :context='self()' v-slot="{bind,on}" field="zip">
                                <v-text-field
                                    :autocomplete="autofillStatus?'kiosk_zip':'off'"
                                    :key="'zip_input'"
                                    v-bind="bind"
                                    v-on="on"
                                ></v-text-field>
                            </with-validation>
                        </v-col>
                    </template>
                    <template v-else>
                        <template v-if="is_international_canadian && !reservation.is_international_customer">
                            <v-col cols="12" md="4">
                                <div class="v-select__slot cus-mt-5 cus-animation" v-on:click="$event.stopPropagation()">
                                    <label for="province" id="provinceLabel" class="cus-select-label v-label v-label--active theme--light">Province</label>
                                    <with-validation :context='self()' v-slot="{bind,on}" field="province">

                                        <select name="state" id="province" v-on:click="addAnimation('provinceLabel')" class="cus-select form-control smaller-list v-text-field v-select__selection--comma v-select" v-model="reservation.province">
                                            <option v-for="(item, key) in states" :value="item.abbreviation" :key="key">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </with-validation>
                                </div>
                            </v-col>
                        </template>
                        <template v-else>
                            <v-col cols="12" md="4">
                                <with-validation :context='self()' v-slot="{bind,on}" field="province">
                                    <v-text-field
                                        :autocomplete="autofillStatus?'kiosk_province':'off'"
                                        v-bind="bind"
                                        v-on="on"
                                    ></v-text-field>
                                </with-validation>
                            </v-col>
                        </template>
                        <v-col cols="12" md="4">
                            <with-validation :context='self()' v-slot="{bind,on}" field="postal_code">
                                <v-text-field
                                    :autocomplete="autofillStatus?'kiosk_postal_code':'off'"
                                    :key="'postal_code_input'"
                                    v-bind="bind"
                                    v-on="on"
                                ></v-text-field>
                            </with-validation>
                        </v-col>
                    </template>
                </v-row>
                <v-expand-transition>
                    <div v-if="!reservation.is_international_customer || reservation.country">
                        <h5 class="mt-5">
                            <v-icon>mdi-card-account-phone</v-icon>
                            Contact info
                        </h5>
                        <v-row>
                            <v-col cols="12" md="4">
                                <with-validation :context='self()' v-slot="{bind,on}" field="phone">
                                    <v-text-field
                                        :autocomplete="autofillStatus?'kiosk_phone_international_customer':'off'"
                                        v-if="reservation.is_international_customer"
                                        v-bind="bind"
                                        v-on="on"
                                    ></v-text-field>
                                    <v-text-field
                                        :autocomplete="autofillStatus?'kiosk_phone':'off'"
                                        v-else-if="is_international_canadian"
                                        v-bind="bind"
                                        v-on="on"
                                        v-mask="dynamicMask"
                                        minlength="15"
                                    ></v-text-field>
                                    <v-text-field
                                        :autocomplete="autofillStatus?'kiosk_phone':'off'"
                                        v-else
                                        v-bind="bind"
                                        v-on="on"
                                        v-mask="'(###) ###-####'"
                                        minlength="15"
                                    ></v-text-field>
                                </with-validation>
                            </v-col>
                            <v-col cols="12" md="4">
                                <with-validation :context='self()' v-slot="{bind,on}" field="email">
                                    <v-text-field
                                        :autocomplete="autofillStatus?'kiosk_email':'off'"
                                        v-bind="bind"
                                        v-on="on"
                                    ></v-text-field>
                                </with-validation>
                            </v-col>
                            <v-col cols="12" md="4">
                                <with-validation :context='self()' v-slot="{bind,on}" field="email_confirmation">
                                    <v-text-field
                                        :autocomplete="autofillStatus?'kiosk_email_confirmation':'off'"
                                        v-bind="bind"
                                        v-on="on"
                                    ></v-text-field>
                                </with-validation>
                            </v-col>
                        </v-row>
                    </div>
                </v-expand-transition>
            </v-col>

        </v-row>
    </v-card>
</template>

<script>
import ValidatableComponent     from "../../../../mixins/ValidatableComponent";
import WithValidation           from "../../../../components/inputs/WithValidation";
import reservation_form__fields from "../../../../validation/fields/reservation_form__fields";
import cc_form__rules           from "../../../../validation/scenarios/cc_form__rules";
import reservation_form__rules  from "../../../../validation/scenarios/reservation_form__rules";
import step_1                   from "../../validation/step_1";

export default {
  name      : "ContactInformation",
  props     : ['validationId'],
  components: {WithValidation},
  mixins    : [ValidatableComponent],
  data      : () => ({
      autofillStatus: true,
  }),
  methods   : {
    testStateInput(stateName) {
      if (stateName) {
        let autoState = this.states.find(s => s.name.toUpperCase() === stateName.toUpperCase() || s.abbreviation === stateName);
        if (autoState) {
          this.$store.commit('set_model_value', {
            path : 'model.reservation.state',
            value: autoState.abbreviation
          })
          this.$refs.state_select.blur();
        }
      }
    },
      addAnimation(id){
          document.getElementById(id).classList.remove('cus-select-label');
          document.getElementById(id).classList.remove('cus-select-label-top-00000099');
          document.getElementById(id).classList.add('cus-select-label-top');
      },
      handleClick(){
          if(this.is_international_canadian && this.$store.state.model.reservation.province==""){
              document.getElementById('provinceLabel').classList.remove('cus-select-label-top');
              document.getElementById('provinceLabel').classList.remove('cus-select-label-top-00000099');
              document.getElementById('provinceLabel').classList.add('cus-select-label');
          }else if(this.$store.state.model.reservation.state==""){
              document.getElementById('stateLabel').classList.remove('cus-select-label-top');
              document.getElementById('stateLabel').classList.remove('cus-select-label-top-00000099');
              document.getElementById('stateLabel').classList.add('cus-select-label');
          }
      },
      processTags(e){
          if(this.$store.state.model.reservation.is_international_customer){
              this.$refs.country_select.$refs.input.focus();
              this.$nextTick(function () {
                  this.$refs.country_select.isMenuActive = true;
              });
          }else{
              this.$refs.address_primary_ref.focus();
          }
          e.preventDefault();
      }

  },
  computed  : {
    reservation() {
      return this.$store.state.model.reservation;
    },
      is_international_canadian(){
          return parseInt(this.$store.state.resources.config.is_international_canadian);
      },
      enable_international_customer(){
          return parseInt(this.$store.state.resources.config.enable_international_customer);
      },
    states() {
        return this.is_international_canadian?this.$store.state.resources.canadian_states:this.$store.state.resources.states;
    },
      dynamicMask() {
          return this.$store.state.resources.config.phone_format;
      },
    countries() {
      return this.$store.state.resources.countries;
    },
    phoneMask() {
      if (this.reservation.is_international_customer) {
        return this.$store.state.resources.phone_masks[this.$store.state.model.reservation.country];
      } else {
        return '(###) ###-####';
      }
    }

  },
  watch     : {
    'reservation.is_international_customer': function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.$refs.country_select.$refs.input.focus();
          this.$nextTick(function () {
            this.$refs.country_select.isMenuActive = true;
          });
        })

      }
    },
      'reservation.state': function (newVal) {
          if (newVal!=="") {
              document.getElementById('stateLabel').classList.remove('cus-select-label');
              document.getElementById('stateLabel').classList.add('cus-select-label-top-00000099');
          }else{
              document.getElementById('stateLabel').classList.remove('cus-select-label-top-00000099');
              document.getElementById('stateLabel').classList.add('cus-select-label');
          }
      },
      'reservation.province': function (newVal) {
          if (newVal!=="") {
              document.getElementById('provinceLabel').classList.remove('cus-select-label');
              document.getElementById('provinceLabel').classList.add('cus-select-label-top-00000099');
          }else{
              document.getElementById('provinceLabel').classList.remove('cus-select-label-top-00000099');
              document.getElementById('provinceLabel').classList.add('cus-select-label');
          }
      },
    validationId(val) {
      if (val) {
        this.withValidation({validationId: val})
      }
    }
  },

  mounted() {
      if(this.is_international_canadian){
          this.$store.state.model.reservation.country = "CA";
      }
    if (this.validationId === false) {
      const self = this;
      this.withValidation(
          {
            getModel() {
              return self.$store.state.model.reservation;
            },
            rules : reservation_form__rules,
            fields: reservation_form__fields
          }
      )
    }
    if (window.location.href.includes('seasonal')) {
            this.autofillStatus = false;
        }
  },
    created(){
        window.addEventListener('click', this.handleClick);
    }
}
</script>

<style>
    h5 > .v-icon {
      margin-bottom: 5px;
    }
    .v-list-item__content {
        padding: 0px !important;
    }
    .v-list-item {
      min-height : 22px !important;
    }
    .cus-select-label{
        position: absolute;
        z-index: 999;
        top: 20px;
    }
    .cus-select-label-top {
        position: absolute;
        z-index: 999;
        top: -3px !important;
        font-size: 12px !important;
        color: #1976d2 !important;
    }
    .cus-select-label-top-00000099 {
        position: absolute;
        z-index: 999;
        top: -3px !important;
        font-size: 12px !important;
        color: #00000099 !important;
    }
    .cus-select{
        border: none !important;
        border-bottom: 1px solid #949494 !important;
        border-radius: 0 !important;
        margin-bottom: 0 !important;
    }
    .cus-select:focus{
        box-shadow: none !important;
    }
    .cus-mt-5{
        margin-top: 5px !important;
    }
    .cus-animation {
        display:inline-block;
        margin:0;
    }
    .cus-animation:after {
        display:block;
        content: '';
        border-bottom: solid 1.5px #1976d2;
        transform: scaleX(0);
        transition: transform 250ms ease-in-out;
    }
    .cus-animation:hover:after, .cus-animation:focus:after {
        transform: scaleX(1);
    }
</style>
